import React from 'react';
import RootStore from './RootStore';

export const RootStoreContext = React.createContext<RootStore | null>(null);
